<script lang="ts" setup>
import Product from '~/components/Product/Product.vue'

const marketplaceLock = useMarketplaceLock()

definePageMeta({
  layout: false,
  key: 'product',
  middleware: 'marketplace',
})
</script>

<template>
  <div>
    <NuxtLayout name="market-page">
      <ClientOnly>
        <template #fallback>
          <div class="flex flex-1 self-center items-center">
            <Loader />
          </div>
        </template>
        <MpLock v-if="!marketplaceLock.isUnlocked.value" />
        <Product v-else />
      </ClientOnly>
    </NuxtLayout>
  </div>
</template>
